var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisclaimerDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.6,16A1.6,1.6,0,0,1,0,14.406V1.6A1.6,1.6,0,0,1,1.6,0H14.4A1.661,1.661,0,0,1,16,1.606V14.4A1.6,1.6,0,0,1,14.4,16Zm.8-1.6H13.6a.8.8,0,0,0,.8-.8V2.4a.8.8,0,0,0-.8-.8H2.4a.8.8,0,0,0-.8.8V13.6A.8.8,0,0,0,2.4,14.4Zm4.8-2.395a.8.8,0,1,1,.8.8A.8.8,0,0,1,7.2,12.005Zm0-2.4v-5.6a.8.8,0,1,1,1.6,0v5.6a.8.8,0,0,1-1.6,0Z",
    fill: "#6b6c6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimerDark);
export default __webpack_public_path__ + "static/media/disclaimerDark.3f9b7920ed7c93bdac21fe2d3bbf8fef.svg";
export { ForwardRef as ReactComponent };